module.exports = __webpack_public_path__ + "static/media/pen-minus.fd51b8fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/pen-minus.svg
// module id = 3295
// module chunks = 7